// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plan-comparison {
  width: 100%;
  margin-bottom: 28px;
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
}

.plan-comparison__heading {
  margin: 0 0 16px;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
}

.plan-comparison__table {
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid;
  border-radius: 12px;
  overflow: hidden;
}

.plan-comparison__table th,
.plan-comparison__table td {
  padding: 12px;
  overflow-wrap: anywhere;
  text-align: left;
  vertical-align: top;
}

.plan-comparison__table thead th {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.plan-comparison__table thead th:first-child {
  width: 27%;
}

.plan-comparison__table tbody th {
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
}

.plan-comparison__table td {
  font-size: 13px;
  line-height: 1.45;
}

.plan-comparison__table tbody tr + tr th,
.plan-comparison__table tbody tr + tr td {
  border-top: 1px solid;
}

.plan-comparison__caption {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.plan-comparison--dark {
  color: #e8e4dc;
}

.plan-comparison--dark .plan-comparison__heading {
  color: #e8e4dc;
}

.plan-comparison--dark .plan-comparison__table {
  background: linear-gradient(180deg, #1a1a1a 0%, #151515 100%);
  border-color: #2a2a2a;
}

.plan-comparison--dark .plan-comparison__table thead th {
  background: rgba(74, 156, 109, 0.12);
  color: #e8e4dc;
}

.plan-comparison--dark .plan-comparison__table thead th:last-child {
  background: rgba(74, 156, 109, 0.24);
  color: #b9dfc7;
}

.plan-comparison--dark .plan-comparison__table tbody th {
  color: #e8e4dc;
}

.plan-comparison--dark .plan-comparison__table td {
  color: #aaa;
}

.plan-comparison--dark .plan-comparison__table tbody td:last-child {
  color: #c5e4d0;
}

.plan-comparison--dark .plan-comparison__table tbody tr + tr th,
.plan-comparison--dark .plan-comparison__table tbody tr + tr td {
  border-top-color: #2a2a2a;
}

.plan-comparison--light {
  color: #2d2d42;
}

.plan-comparison--light .plan-comparison__heading {
  color: #2d2d42;
}

.plan-comparison--light .plan-comparison__table {
  background: #fff;
  border-color: #e1e1eb;
}

.plan-comparison--light .plan-comparison__table thead th {
  background: #f4f3fc;
  color: #4d4d68;
}

.plan-comparison--light .plan-comparison__table thead th:last-child {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}

.plan-comparison--light .plan-comparison__table tbody th {
  color: #303044;
}

.plan-comparison--light .plan-comparison__table td {
  color: #5a5a6a;
}

.plan-comparison--light .plan-comparison__table tbody td:last-child {
  color: #6247a1;
  font-weight: 600;
}

.plan-comparison--light .plan-comparison__table tbody tr + tr th,
.plan-comparison--light .plan-comparison__table tbody tr + tr td {
  border-top-color: #e8e7f0;
}

.mobile-auth .plan-comparison--light .plan-comparison__heading {
  color: #e8e8e8;
}

@media (max-width: 768px) {
  .plan-comparison__heading {
    font-size: 20px;
    margin-bottom: 12px;
  }

  .plan-comparison__table th,
  .plan-comparison__table td {
    padding: 10px 8px;
  }
}

@media (max-width: 480px) {
  .plan-comparison__heading {
    font-size: 18px;
  }

  .plan-comparison__table {
    border-radius: 10px;
  }

  .plan-comparison__table th,
  .plan-comparison__table td {
    padding: 8px 6px;
  }

  .plan-comparison__table thead th,
  .plan-comparison__table tbody th,
  .plan-comparison__table td {
    font-size: 11px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/client/components/PlanComparison.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;;IAGE,eAAe;EACjB;AACF","sourcesContent":[".plan-comparison {\n  width: 100%;\n  margin-bottom: 28px;\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n}\n\n.plan-comparison__heading {\n  margin: 0 0 16px;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.25;\n  text-align: center;\n}\n\n.plan-comparison__table {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n  border-spacing: 0;\n  border: 1px solid;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.plan-comparison__table th,\n.plan-comparison__table td {\n  padding: 12px;\n  overflow-wrap: anywhere;\n  text-align: left;\n  vertical-align: top;\n}\n\n.plan-comparison__table thead th {\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.plan-comparison__table thead th:first-child {\n  width: 27%;\n}\n\n.plan-comparison__table tbody th {\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.35;\n}\n\n.plan-comparison__table td {\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.plan-comparison__table tbody tr + tr th,\n.plan-comparison__table tbody tr + tr td {\n  border-top: 1px solid;\n}\n\n.plan-comparison__caption {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.plan-comparison--dark {\n  color: #e8e4dc;\n}\n\n.plan-comparison--dark .plan-comparison__heading {\n  color: #e8e4dc;\n}\n\n.plan-comparison--dark .plan-comparison__table {\n  background: linear-gradient(180deg, #1a1a1a 0%, #151515 100%);\n  border-color: #2a2a2a;\n}\n\n.plan-comparison--dark .plan-comparison__table thead th {\n  background: rgba(74, 156, 109, 0.12);\n  color: #e8e4dc;\n}\n\n.plan-comparison--dark .plan-comparison__table thead th:last-child {\n  background: rgba(74, 156, 109, 0.24);\n  color: #b9dfc7;\n}\n\n.plan-comparison--dark .plan-comparison__table tbody th {\n  color: #e8e4dc;\n}\n\n.plan-comparison--dark .plan-comparison__table td {\n  color: #aaa;\n}\n\n.plan-comparison--dark .plan-comparison__table tbody td:last-child {\n  color: #c5e4d0;\n}\n\n.plan-comparison--dark .plan-comparison__table tbody tr + tr th,\n.plan-comparison--dark .plan-comparison__table tbody tr + tr td {\n  border-top-color: #2a2a2a;\n}\n\n.plan-comparison--light {\n  color: #2d2d42;\n}\n\n.plan-comparison--light .plan-comparison__heading {\n  color: #2d2d42;\n}\n\n.plan-comparison--light .plan-comparison__table {\n  background: #fff;\n  border-color: #e1e1eb;\n}\n\n.plan-comparison--light .plan-comparison__table thead th {\n  background: #f4f3fc;\n  color: #4d4d68;\n}\n\n.plan-comparison--light .plan-comparison__table thead th:last-child {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: #fff;\n}\n\n.plan-comparison--light .plan-comparison__table tbody th {\n  color: #303044;\n}\n\n.plan-comparison--light .plan-comparison__table td {\n  color: #5a5a6a;\n}\n\n.plan-comparison--light .plan-comparison__table tbody td:last-child {\n  color: #6247a1;\n  font-weight: 600;\n}\n\n.plan-comparison--light .plan-comparison__table tbody tr + tr th,\n.plan-comparison--light .plan-comparison__table tbody tr + tr td {\n  border-top-color: #e8e7f0;\n}\n\n.mobile-auth .plan-comparison--light .plan-comparison__heading {\n  color: #e8e8e8;\n}\n\n@media (max-width: 768px) {\n  .plan-comparison__heading {\n    font-size: 20px;\n    margin-bottom: 12px;\n  }\n\n  .plan-comparison__table th,\n  .plan-comparison__table td {\n    padding: 10px 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .plan-comparison__heading {\n    font-size: 18px;\n  }\n\n  .plan-comparison__table {\n    border-radius: 10px;\n  }\n\n  .plan-comparison__table th,\n  .plan-comparison__table td {\n    padding: 8px 6px;\n  }\n\n  .plan-comparison__table thead th,\n  .plan-comparison__table tbody th,\n  .plan-comparison__table td {\n    font-size: 11px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
